module.exports = __webpack_public_path__ + "img/logo.9db9dcfe.jpg";